import { Button } from '../atoms/Button/Button';
import { Text } from '../atoms/Typography/Text';
import { useTranslation } from '../../i18n/useTranslation';
import type { MentorConversationSummary } from '../../services/mentorService';
import './Mentor.css';

export interface MentorConversationListProps {
  conversations: readonly MentorConversationSummary[];
  activeId: string | null;
  onOpen: (id: string) => void;
  onDelete: (conversation: MentorConversationSummary) => void;
}

/** Past conversations of the aquarium, most recently active first. */
export function MentorConversationList({ conversations, activeId, onOpen, onDelete }: MentorConversationListProps) {
  const { t, i18n } = useTranslation();
  const date = new Intl.DateTimeFormat(i18n.language || 'en', { dateStyle: 'medium' });

  return (
    <ul className="mentor-conversations" data-testid="mentor-conversations">
      {conversations.map((conversation) => {
        const title = conversation.title || t('mentor.list.untitled');
        const active = conversation.id === activeId;
        return (
          <li key={conversation.id} className={`mentor-conversations__item${active ? ' mentor-conversations__item--active' : ''}`}>
            <Button
              variant="ghost"
              size="sm"
              className="mentor-conversations__open"
              onClick={() => onOpen(conversation.id)}
              aria-current={active ? 'true' : undefined}
            >
              <span className="mentor-conversations__title">{title}</span>
            </Button>
            <Text variant="caption" className="mentor-conversations__meta">
              {t('mentor.list.meta', { date: date.format(new Date(conversation.updatedAt)), count: conversation.messageCount })}
            </Text>
            <Button
              variant="ghost"
              size="sm"
              className="mentor-conversations__delete"
              onClick={() => onDelete(conversation)}
              aria-label={t('mentor.list.deleteLabel', { title })}
            >
              {t('mentor.list.delete')}
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
